import React from "react";

const BlankLayout = props => <>{props.children}</>;

export default BlankLayout;
